import { connect } from "react-redux";
import SubleaguePanel from "../SubleaguePanel.jsx";
import { branch, compose, renderNothing } from "recompose";

const mapStateToProps = (state) => {
  return {
    game: state.games.current,
    open: state.subleagues.openEntries,
    subleague: state.subleagues.current,
    classification: state.classifications.current,
    showMoreButton: state.subleagues.showMoreButton,
  };
};

const SubleaguePanelContainer = compose(
  connect(mapStateToProps),
  branch(
    ({ subleague, classification }) => !subleague || !classification,
    renderNothing
  )
)(SubleaguePanel);

export default SubleaguePanelContainer;
